import { atom } from 'recoil'
import { IngredientTypes } from '../types/ingredients/IngredientTypes'

export const ingredientTypes = atom({
  key: 'ingredientTypes',
  default: [] as IngredientTypes[],
})
